module.exports = __webpack_public_path__ + "static/media/img-ative-tag@3x.731d6d36.png";